// Shopify's `payment_gateway_names` mixes machine handles ("shopify_payments",
// "gift_card") with checkout display names ("Cash on Delivery (COD)").
// Title-case the handles; leave display names untouched.
export function formatPaymentGatewayName(gatewayName: string): string {
  if (!/^[a-z0-9]+(_[a-z0-9]+)*$/.test(gatewayName)) {
    return gatewayName;
  }
  return gatewayName
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
